import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let ImageFields = {
    'main_author': {
        display: {
            name: '主要作者',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'main_author',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'era_ad': {
        display: {
            name: '年代(西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'era_none_ad': {
        display: {
            name: '年代(非西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_none_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'filming_location': {
        display: {
            name: '拍攝地點',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'filming_location',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'language': {
        display: {
            name: '語言',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'language',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multiple-select-as-is',
            options: {
                type: 'fixed',
                list: ['中文','英文','日文'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'color': {
        display: {
            name: '色彩',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'color',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['彩色','黑白'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'quantity': {
        display: {
            name: '數量',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'quantity',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'acquire_method': {
        display: {
            name: '取得方式',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'acquire_method',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['徵求','蒐訪','複製','採購','捐贈','交換','授權','機關保管'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'acquire_date': {
        display: {
            name: '取得日期',
            type: 'datetime',
        },
        source: {
            type: 'db',
            key: 'acquire_date',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'provider': {
        display: {
            name: '提供者',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'provider',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'provider_contact': {
        display: {
            name: '提供者聯絡資訊',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'provider_contact',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multi-string'
        }
    },
    'handle_man': {
        display: {
            name: '經手人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'handle_man',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
}

let Image = (front_back) => {

    let fields = null
    if (front_back === 'backstage') {
        fields = [
            ImageFields['main_author'],
            ImageFields['era_ad'],
            ImageFields['era_none_ad'],
            ImageFields['filming_location'],
            ImageFields['language'],
            ImageFields['color'],
            ImageFields['quantity'],
            ImageFields['acquire_method'],
            ImageFields['acquire_date'],
            ImageFields['provider'],
            ImageFields['provider_contact'],
            ImageFields['handle_man'],
        ]
    }
    else {
        fields = [
            ImageFields['main_author'],
            ImageFields['era_ad'],
            ImageFields['era_none_ad'],
            ImageFields['filming_location'],
            ImageFields['language'],
            ImageFields['color'],
            ImageFields['quantity'],
            ImageFields['acquire_method'],
            ImageFields['acquire_date'],
            ImageFields['provider'],
            // ImageFields['provider_contact'],
            // ImageFields['handle_man'],
        ]
    }

    return {
        name: '影像資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('image', front_back),
        ForestryData('image', front_back),
        Image(front_back), 
        Rights('image', front_back), 
        PhysicalObject('image', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '影像',
        type: 'group',
        fields
    }    
}
  